import { ColDef, ValueGetterParams } from '@ag-grid-community/core';

import { TableConstants } from '@shared/constants/table.constants';
import { Currency } from '@shared/services/gql.service';
import { Utils } from '@shared/utils/utils';

import { SiteSummaryGridContext } from '../types/site-summary-grid-context';
import { SiteSummaryGridRow } from '../types/site-summary-grid-row';

const costColumnConfig = {
  cellClass: TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT,
  maxWidth: 400,
  minWidth: 162,
  width: 162,
};

export const getCostColumns = (
  ctx: SiteSummaryGridContext,
  aggregateBy: 'frequencies' | 'visitCosts',
  costField: SiteSummaryGridRow['frequencies'] | string
): ColDef<SiteSummaryGridRow> => {
  return {
    ...costColumnConfig,
    valueFormatter: (params) =>
      Utils.agCurrencyFormatter(
        params,
        ctx.isSelectedCurrencyContracted
          ? params.data?.contractedCurrency || Currency.USD
          : Currency.USD
      ),
    valueGetter: (params) => {
      const contractedCurrency = params.data?.contractedCurrency || Currency.USD;

      return getCostValueByAggregationType(
        params,
        aggregateBy,
        costField,
        ctx.isSelectedCurrencyContracted ? contractedCurrency : Currency.USD
      );
    },
  };
};

const getCostValueByAggregationType = (
  params: ValueGetterParams<SiteSummaryGridRow>,
  aggregateBy: 'frequencies' | 'visitCosts',
  costField: SiteSummaryGridRow['frequencies'] | string,
  currency: Currency
): number => {
  const aggregatedCosts = params.data?.[aggregateBy] ?? {};
  const typedCostField =
    aggregateBy === 'frequencies'
      ? (costField as keyof SiteSummaryGridRow['frequencies'])
      : (costField as keyof SiteSummaryGridRow['visitCosts']);

  return aggregatedCosts[typedCostField]?.[currency] ?? 0;
};
